// extracted by mini-css-extract-plugin
export default {"space":"EditAndSaveActions_space__Zq9en","wrapper":"EditAndSaveActions_wrapper__1vHjX","item":"EditAndSaveActions_item__PorH9","h4":"EditAndSaveActions_h4__AKHc5"};